import { HOST_PRODUCT, HOST, HOST_NEST } from 'src/utils/domain';

export default {
  // ===================== Product API =====================
  GET_LIST_PRODUCT_DEAL_HOME: `${HOST_PRODUCT}/stock/category/home`,

  GET_SHIPPING_INFO: website =>
    `${HOST_PRODUCT}/stock/website/list?website=${website}`,

  GET_CATEGORY_DETECT: `${HOST_PRODUCT}/stock/category/detect`,

  GET_LIST_WEBSITE_FILTER_CATALOG: `${HOST_PRODUCT}/stock/website/list`,

  POST_SCRAPER: `${HOST_PRODUCT}/scraper`,

  GET_LIST_CATALOG_LOOKING: `${HOST_PRODUCT}/stock/search`,

  GET_LIST_FOR_YOU: `${HOST_PRODUCT}/stock/product/foryou`,

  GET_DETAIL_CATALOG_AWS: slug_id => `${HOST_PRODUCT}/stock/product/${slug_id}`,

  GET_LIST_FAVORITE: `${HOST_PRODUCT}/stock/product/favorite`,

  GET_LIST_FLASH_SALE_AWS: `${HOST_PRODUCT}/stock/product/tags`,

  GET_CATEGORIES: `${HOST_PRODUCT}/stock/category/list`,

  GET_PRODUCT_BY_CATEGORY: slug_id => `${HOST_PRODUCT}/stock/category/${slug_id}`,

  // ===================== NodeJS API =====================
  POST_MANUAL_SIGN_IN: `${HOST}/mp/customer/auth/account-sign-in`,

  POST_SIGN_IN: `${HOST}/mp/customer/auth/google-sign-in`,

  POST_SIGN_IN_WITH_OAUTH2: `${HOST}/mp/customer/auth/facebook-sign-in`,

  VERIFY_EMAIL_AND_AUTO_LOGIN: `${HOST}/mp/customer/auth/verify-manual-sign-up`,

  SIGN_UP_MANUAL: `${HOST}/customer/auth/sign-up`,

  POST_REFRESH_TOKEN: `${HOST}/customer/auth/refresh-token`,

  FORGOT_PASSWORD: `${HOST}/customer/auth/forgot-password`,

  CHANGE_PASSWORD: `${HOST}/customer/auth/forgot-password-verify`,

  SIGN_UP_PHONE: `${HOST}/customer/auth/sign-up-phone`,

  IGNORE_VERIFY_PHONE: `${HOST}/customer/auth/sign-up-phone-ignore`,

  RESEND_EMAIL: `${HOST}/customer/auth/resend-email-verify`,

  // ==========================================

  CHECK_LOGIN_PROVIDER: `${HOST}/mp/customer/user/login-providers`,

  VERIFY_PHONE: `${HOST}/mp/customer/user/verify-phone`,

  CHANGE_USER_PASSWORD: `${HOST}/mp/customer/user/change-password`,

  PUT_USER_PROFILE_PREFIX: `${HOST}/customer/user/update-prefix`,

  POST_VERIFY_EMAIL: `${HOST}/customer/user/verify-email`,

  PUT_UPDATE_FCM_TOKEN: `${HOST}/customer/user/fcm-token`,

  CLOSE_EXTENSION: `${HOST}/customer/user/extension-ignore`,

  // ==========================================

  UPLOAD_IMAGE: `${HOST}/mp/customer/s3/upload/image`,

  UPLOAD_FILE: `${HOST}/public/upload/file-webapp`,

  // ==========================================

  TRACKING_LIST: `${HOST}/customer/tracking/list`,

  TRACKING_DETAIL: `${HOST}/customer/tracking/detail`,

  // ==========================================

  GET_SELECTED_SALE_ORDER: `${HOST}/customer/sale-orders/selected`,

  GET_SHIPPING_CATEGORIES: `${HOST}/customer/sale-orders/shipping-categories`,

  POST_CREATE_SALE_ORDER: `${HOST}/customer/sale-orders/create`,

  PUT_UPDATE_SALE_ORDER: `${HOST}/customer/sale-orders/update`,

  PUT_UPDATE_QUOTATION: id => `${HOST}/customer/sale-orders/update/${id}`,

  GET_LIST_SALE_ORDER: `${HOST}/customer/sale-orders/list`,

  GET_SALE_ORDER: `${HOST}/customer/sale-orders/detail`,

  GET_POLICY: type =>
    `${HOST}/cms/customer/checker-policy?filters[$and][0][type][$eq]=${type}`,

  // ==========================================

  GET_WEBSITE_DISABLE_US: `${HOST}/customer/website/disable`,

  // ==========================================

  DETAIL_CONFIRM_VN_TRACKING: id =>
    `${HOST}/mp/customer/user/get-money-tranfer-request/${id}`,

  GET_LIST_TRANSACTION: `${HOST}/mp/customer/user/transaction`,

  UPDATE_FIRST_LOGIN: `${HOST}/mp/customer/user/update-first-login`,

  GET_TRANSFER_REQUEST: `${HOST}/mp/customer/user/get-money-tranfer-request`,

  GET_DETAIL_TRANSACTION: id => `${HOST}/mp/customer/user/payment/${id}`,

  GET_MONEY_REQUEST: `${HOST}/customer/user/get-money-request`,

  // ==========================================

  REGISTER_SHIPPING_SERVICE: `${HOST}/mp/customer/order-shipping/register`,

  GET_LIST_ADDRESS_SHIPPING: `${HOST}/mp/customer/order-shipping/address`,

  GET_LIST_TRACKING_SHIPPING: `${HOST}/mp/customer/order-shipping/tracking`,

  // ==========================================

  GET_DETAIL_MANAGEMENT: id => `${HOST}/customer/order-tracking/detail/${id}`,

  GET_TRACKING_DETAIL: sale_order_id =>
    `${HOST}/customer/order-tracking/tracking-of-sale-order/${sale_order_id}`,

  GET_TRACKING_JOURNEY: (id, type) =>
    `${HOST}/customer/order-tracking/journeys/${id}/${type}`,

  GET_TRACKING_JOURNEY_BY_ORDER: id =>
    `${HOST}/customer/order-tracking/tracking-and-journey/${id}`,

  // ==========================================

  GET_LIST_VN_TRACKING: `${HOST}/customer/vn-tracking/list`,

  GET_VN_TRACKING_DETAIL: tracking_id =>
    `${HOST}/customer/vn-tracking/detail/${tracking_id}`,

  // ==========================================

  GET_DEBT_RECOVERY: id => `${HOST}/mp/customer/debt-recovery/${id}`,

  UPDATE_WAITING_SALE_ORDER: `${HOST}/mp/customer/sale-order-v2/update-waiting-sale-order`,

  GET_LIST_BANK: type => `${HOST}/mp/customer/bank-transfer/detail/${type}`,

  GET_REFERRAL: `${HOST}/customer/referral`,

  EXCHANGE_POINT: `${HOST}/customer/point/withdraw`,

  // ===================== NestJS API =====================
  GET_CONFIGURATION: `${HOST_NEST}/configuration`,

  GET_PAYMENT_GATEWAY_INFO: id => `${HOST_NEST}/sale-order/payment-gateway/${id}`,

  CONFIRM_VN_TRACKING: `${HOST_NEST}/customer/user/send-top-up-request`,

  GET_NOTIFICATION: `${HOST_NEST}/customer/notification`,

  GET_LIST_BANK_NEW: `${HOST_NEST}/customer/user/get-bank-for-top-up`,

  MARK_AS_READ_NOTIFICATION: `${HOST_NEST}/customer/notification/read`,

  SEND_MONEY_TRANFER_REQUEST: `${HOST_NEST}/customer/user/send-top-up-request`,

  SEND_MONEY_WITHDRAW_REQUEST: `${HOST_NEST}/customer/user/send-withdraw-request`,

  CHECK_PRICE_PRODUCT: `${HOST_NEST}/cart/check-price`,

  DELETE_QUOTATION: id => `${HOST_NEST}/cart/${id}`,

  GET_LIST_CHECKER_PROFILE: id => `${HOST_NEST}/sale-order/checker-info/${id}`,

  GET_LIST_CHECKER_AVAILABLE: `${HOST_NEST}/customer/checker-profile/available`,

  GET_CURRENT_SALE_ORDER: `${HOST_NEST}/cart`,

  POST_CONFIRM_SALE_ORDER: `${HOST_NEST}/pay/confirm`,

  POST_CONFIRM_SHOPPING_CART: `${HOST_NEST}/checkout/order`,

  ADD_SHOPPING_CART: `${HOST_NEST}/cart`,

  EDIT_SALE_ORDER_IMPROVEMENT: id => `${HOST_NEST}/cart/${id}`,

  GET_PROMOTION: `${HOST_NEST}/store-promotion`,

  GET_PROMOTION_ANONYMOUS: anonymous_id =>
    `${HOST_NEST}/store-promotion/anonymous/${anonymous_id}`,

  CREATE_NEW_PROMOTION: `${HOST_NEST}/store-promotion`,

  DELETE_PROMOTION: `${HOST_NEST}/store-promotion`,

  ADD_SHOPPING_CART_ANONYMOUS: `${HOST_NEST}/cart-anonymous`,

  EDIT_SALE_ORDER_ANONYMOUS: cart_item_id =>
    `${HOST_NEST}/cart-anonymous/${cart_item_id}`,

  GET_SHOPPING_CART_ANONYMOUS: anonymous_id =>
    `${HOST_NEST}/cart-anonymous/${anonymous_id}`,

  DELETE_SHOPPING_CART_ANONYMOUS: ({ id, anonymous_id }) =>
    `${HOST_NEST}/cart-anonymous/${anonymous_id}/${id}`,

  PUT_UPDATE_USER_PROFILE: `${HOST_NEST}/customer/user`,

  GET_USER_PROFILE: `${HOST_NEST}/customer/user`,

  PUT_SELECT_ADDRESS: addressId => `${HOST_NEST}/user-address/selected/${addressId}`,

  POST_CREATE_NEW_ADDRESS: `${HOST_NEST}/user-address`,

  RESET_DELIVERY_ADDRESS: addressId =>
    `${HOST_NEST}/user-address/selected-return-full-cart/${addressId}`,

  DELETE_ADDRESS: addressId => `${HOST_NEST}/user-address/${addressId}`,

  EDIT_DELIVERY_ADDRESS: addressId => `${HOST_NEST}/user-address/${addressId}`,

  GET_DEAL_DETAIL: deal_id => `${HOST_NEST}/customer/deal/${deal_id}`,

  DELETE_SELECTED_CART_ITEMS: `${HOST_NEST}/cart`,

  DELETE_SELECTED_ANONYMOUS_CART_ITEMS: `${HOST_NEST}/cart-anonymous`,

  PUT_TO_LOGGED_CART: anonymous_id =>
    `${HOST_NEST}/cart-anonymous/push-to-logged-cart/${anonymous_id}`,

  GET_ORDER_PURCHASE_REVIEW: order_id =>
    `${HOST_NEST}/sale-order/purchase-review/${order_id}`,

  REORDER_SALE_ORDER: `${HOST_NEST}/sale-order/reorder-sale-order`,

  GET_LIST_CHECKER: `${HOST_NEST}/customer/checker-profile/available`,

  GET_LIST_FAVORITE_DEAL: `${HOST_NEST}/customer/deal`,

  GET_PROVINCE: `${HOST_NEST}/subdivision/provinces`,

  GET_DISTRICT: provinceId =>
    `${HOST_NEST}/subdivision/provinces/${provinceId}/districts`,

  GET_WARD: (provinceId, districtId) =>
    `${HOST_NEST}/subdivision/provinces/${provinceId}/districts/${districtId}/wards`,

  GET_LIST_PROMOTION: `${HOST_NEST}/sale-coupon-program`,

  GET_VIETQR: `${HOST_NEST}/qrpay/vietqr`,

  INPUT_PROMOTION: code => `${HOST_NEST}/sale-coupon-program/reserved/${code}`
};
